import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

/**
 * The list route and the detail (create/update) responses share this exact shape — no `Computed`
 * transform is needed: unlike beneficiaries, a contact carries no date field.
 */
export type BeneficiaryContactPayload = {
	readonly id: number;
	readonly firstName: string;
	readonly lastName: string;
	readonly role: LabeledValuePayload | null;
	readonly isPersonOfTrust: boolean;
	readonly roleDetails: string | null;
	readonly relationship: LabeledValuePayload;
	readonly phoneNumber: string | null;
	readonly email: string | null;
	readonly notes: string | null;
	readonly facility: { readonly id: number };
};

export type BeneficiaryContactsFetchedPayload = {
	totalRecords: number;
	results: BeneficiaryContactPayload[];
};

export type BeneficiaryContactsFetchedAction = {
	type: 'BENEFICIARY_CONTACTS_FETCHED';
	payload: BeneficiaryContactsFetchedPayload;
	beneficiaryId: number;
};

export default (
	payload: BeneficiaryContactsFetchedPayload,
	beneficiaryId: number,
): BeneficiaryContactsFetchedAction => ({
	type: 'BENEFICIARY_CONTACTS_FETCHED',
	payload,
	beneficiaryId,
});
